import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import queryString from 'query-string';
import InfiniteScroll from 'react-infinite-scroll-component';

import pandgLogo from '../../images/pandg.png';
import {
  search,
  moreSearch,
  getSearchCategoryDescription,
  searchInsteadClicked,
  relatedProductClicked,
} from '../../actions';
import Product from '../../components/Product/Product';
import Loading from '../../components/Loading/Loading';
import {
  Container,
  BreadCrumb,
  BreadCrumbLinks,
  CurrentPage,
  FiltersWrapper,
  FiltersScrollArea,
  FilterOverlayBackdrop,
  FilterInfo,
  ResultsPanel,
  ResultsWrapper,
  ResultsTitle,
  Title,
  NoResult,
  CorrectionBanner,
  CorrectedQuery,
  SearchInsteadButton,
  RelatedSection,
  RelatedHeading,
  RelatedHeadingRow,
  RelatedSubheading,
  RelatedGrid,
  NoResultQuery,
  LoadMore,
  ClearFilter,
  FilterPillsWrapper,
  FilterPill,
  FiltersButtons,
  ClearFilterButton,
  DoneButton,
  LoadMoreButton,
  FilterButtonWrapper,
  FilterButton,
  Status,
  Separator,
  NameWrapper,
  BreadCrumbResult,
  CategoryDescription,
  ToolBar,
  ProductCount,
  SortWrapper,
  SortButton,
  SortDropdownPanel,
  SortDropdownItem,
  PandgBannerSection,
  PandgBanner,
  PandgBannerImg,
  PandgBannerOverlay,
  PandgBannerContent,
  PandgLogoBadge,
  PandgLogo,
  PandgEyebrow,
  PandgHeading,
  PandgSub,
  PandgPillSection,
  PandgPillStrip,
  PandgChip,
  PandgChipDot,
  HalalBannerSection,
  HalalBanner,
  HalalBannerImg,
  HalalBannerOverlay,
  HalalBannerContent,
  HalalCertBadge,
  HalalHeading,
  HalalSub,
  HalalPillSection,
  HalalPillStrip,
  HalalChip,
  HalalChipDot,
} from './SearchPage.style';
import {LeftLine, RightLine} from '../../styles/components/lines';
import Filters from '../../components/Filters/Filters';
import {
  JJ_LOCAL_STORAGE,
  PAGE_SIZE,
  ROUTES,
  SEARCH_SORT_TYPE,
  SEARCH_SORT_OPTIONS,
  CURATED_LIST_SORT_OPTION,
  MATCH_ALL_QUERY,
  ANALYTICS_SOURCES,
  SEARCH_PARAMS,
  SCROLL_THRESHOLD,
  SEARCH_ADVANCED_PARAMS,
  SORT_TYPES,
  DESCRIPTIONS,
  FILTERS_NAME,
  LONG_CATEGORY_LIST_FILTER_LENGTH,
  QUERY_PROMO_TAG_ID,
  SEARCH_CORRECTED_PREFIX,
  SEARCH_INSTEAD_PREFIX,
  SEARCH_CORRECT_PARAM,
  SEARCH_CORRECT_OFF,
  SEARCH_RELATED_PARAM,
  SEARCH_RELATED_OFF,
  RELATED_STRATEGY,
  NO_RESULTS_MESSAGE,
  NO_RESULTS_FOR_QUERY_PREFIX,
  getInitialPageSize,
} from '../../constants/constants';
import {
  PANDG_CATEGORIES,
  PANDG_ALL_CATEGORY,
  PANDG_BANNER_IMAGE_URL,
  HALAL_CATEGORIES,
  HALAL_ALL_CATEGORY,
  HALAL_BANNER_IMAGE_URL,
} from '../../constants/search.constants';
import {setCurrentRoute} from '../../actions';
import {
  getBranchFromUrl,
  getBreadCrumbLinks,
  getCategoryName,
  getCategoryNamesFromUrl,
  getDisplayName,
  getSearchHeading,
  getTotalCount,
  titleCase,
  trimComma,
} from '../../helpers/data.helper';
import {getDataFromLocalStorage} from '../../helpers/localStorage.helper';
import {
  getRelatedHeading,
  isRelatedProductsOff,
  isTypedSearch,
} from '../../helpers/search.helper';
import BreadCrumbLink from './BreadCrumbLink';
import FeaturedProduct from '../../components/Product/FeaturedProduct';
import {
  spliceFeaturedIntoResults,
  syncBasketQuantityWithProducts,
} from '../../helpers/product.helper';
import {
  BRAND_PATH,
  CATEGORY_LEVEL1_PATH,
  CATEGORY_LEVEL2_PATH,
  CATEGORY_LEVEL3_PATH,
  CATEGORY_ROOT_PATH,
  SEARCH_PATH,
} from '../../constants/routePaths';
import {setCmsHeadTags, setPageHeadTags} from '../../helpers/seo.helper';
import {loadSearchResultsData} from '../../routes/loadDataForRoutes';
import ToTheTop from '../../components/ToTheTop/ToTheTop';
import {setPrevRoute} from '../../actions/prevRoute.action';

class SearchPage extends PureComponent {
  static propTypes = {
    searchResultsData: PropTypes.array,
    featuredResultsData: PropTypes.array,
    searchMeta: PropTypes.shape({
      searchId: PropTypes.string,
      query: PropTypes.string,
      correctedQuery: PropTypes.string,
    }),
    relatedProductsData: PropTypes.shape({
      parentSearchId: PropTypes.string,
      searchId: PropTypes.string,
      strategy: PropTypes.string,
      title: PropTypes.string,
      results: PropTypes.array,
    }),
    searchInsteadClicked: PropTypes.func,
    relatedProductClicked: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const {location, deviceInfo, match, searchResultsData} = props;
    let updatingUrl = false;
    this.searchTitleForSSR = null;
    this.adTitleDescription = null;
    this.firstSearch = searchResultsData && searchResultsData.length > 0;
    this._savedScrollY = 0;
    this._skipNextScrollToTop = false;
    this.filtersScrollRef = React.createRef();
    this.sortWrapperRef = React.createRef();
    let urlParams;
    if (typeof window !== 'undefined' && window.location) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      urlParams = Object.fromEntries(urlSearchParams.entries());
    }
    const hideDes = !!urlParams && urlParams.noDes === 'true';
    if (match && match.path === SEARCH_PATH && typeof window !== 'undefined') {
      if (
        urlParams &&
        urlParams.adTitle &&
        urlParams.adTitle.toLowerCase() &&
        !hideDes &&
        DESCRIPTIONS[urlParams.adTitle.toLowerCase()]
      ) {
        this.adTitleDescription = DESCRIPTIONS[urlParams.adTitle.toLowerCase()];
      }
    }
    if (match && match.path !== SEARCH_PATH && match.params) {
      let params = {};
      switch (match.path) {
        case BRAND_PATH: {
          const {brandName} = match.params;
          params = Object.assign({}, SEARCH_ADVANCED_PARAMS, {
            b: getBranchFromUrl(match),
            brand: brandName,
            size: getInitialPageSize(),
          });
          this.searchTitleForSSR = brandName;
          updatingUrl = true;
          break;
        }
        case CATEGORY_ROOT_PATH:
        case CATEGORY_LEVEL1_PATH:
        case CATEGORY_LEVEL2_PATH:
        case CATEGORY_LEVEL3_PATH: {
          const {
            brandName,
            category1Name,
            category2Name,
            category3Name,
          } = match.params;
          params = Object.assign({}, SEARCH_ADVANCED_PARAMS, {
            b: getBranchFromUrl(match),
            brand: brandName,
            size: getInitialPageSize(),
          });
          const categoryNames = getCategoryNamesFromUrl(
            category1Name,
            category2Name,
            category3Name
          );
          if (categoryNames.length > 0) {
            params = {
              ...params,
              ...{sortType: SORT_TYPES.CATEGORY},
              ...{categoryNames},
            };
          }
          this.searchTitleForSSR = titleCase(
            trimComma(getCategoryName(categoryNames))
          );
          updatingUrl = true;
          break;
        }
      }
      if (updatingUrl) {
        this.updateSearchUrl(props.history, params);
      }
    }
    this.state = {
      params: null,
      gridView: !(deviceInfo && deviceInfo.isPhone),
      showFilterInMobile: false,
      showSortDropdown: false,
      isCurrentSearch: false,
      searchTitle:
        (location && location.state && location.state.searchTitle) ||
        this.searchTitleForSSR ||
        null,
      hideDes,
      totalCategoryListCount: 0,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.location.search !== prevState.search) {
      const {location, branch, history} = nextProps;
      const params = queryString.parse(location.search);
      const prevParams = queryString.parse(prevState.search);
      if (
        !params.b &&
        !params.size &&
        (params.q || params.first || params.listId || params.brandOwner)
      ) {
        const newParams = Object.assign({}, params, {
          b: branch,
          size: getInitialPageSize(),
        });
        history.replace({
          pathname: '/search',
          search: queryString.stringify(newParams),
        });
      }
      return {
        params,
        search: location.search,
        isCurrentSearch:
          params.q === prevParams.q &&
          params.listId === prevParams.listId &&
          params.brandOwner === prevParams.brandOwner,
      };
    }
    return null;
  }

  lockBodyScroll = () => {
    this._savedScrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
  };

  unlockBodyScroll = () => {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, this._savedScrollY);
  };

  handleSortOutsideClick = e => {
    if (
      this.sortWrapperRef.current &&
      !this.sortWrapperRef.current.contains(e.target)
    ) {
      this.setState({showSortDropdown: false});
    }
  };

  toggleSortDropdown = () =>
    this.setState(prev => ({showSortDropdown: !prev.showSortDropdown}));

  selectSort = value => {
    this.updateSearchParams({sortType: value}, true);
    this.setState({showSortDropdown: false});
  };

  componentWillUnmount() {
    this.unlockBodyScroll();
    document.removeEventListener('mousedown', this.handleSortOutsideClick);
  }

  async componentDidMount() {
    const {
      fulfillmentDetails,
      isNew,
      prevRoute,
      search,
      route,
      setCurrentRoute,
      history,
      location,
      getSearchCategoryDescription,
      searchCategoryDescription,
      setPrevRoute,
    } = this.props;
    setPrevRoute(ROUTES.SEARCH_RESULTS);
    document.addEventListener('mousedown', this.handleSortOutsideClick);
    const authToken = await getDataFromLocalStorage(JJ_LOCAL_STORAGE.TOKEN);
    this.fulfillmentDetailsFromLocal = await getDataFromLocalStorage(
      JJ_LOCAL_STORAGE.FULFILLMENT
    );
    const {state} = location;
    // reset the search title router state after redirect
    if (state && state.searchTitle) {
      const state = {state: {}};
      history.replace({
        ...location,
        state,
      });
    }
    // stop trigger a new search which causes page reload
    // solution for navigate back from product detail page
    if (
      route === ROUTES.PRODUCT &&
      (!location.state || (location.state && !location.state.newSearch)) &&
      isNew
    ) {
      setCurrentRoute(ROUTES.SEARCH_RESULTS);
      return;
    }
    setCurrentRoute(ROUTES.SEARCH_RESULTS);
    const isNewSearch =
      history.location &&
      history.location.state &&
      history.location.state.newSearch;
    if (isNewSearch) {
      const newState = {...history.location.state};
      delete newState.newSearch;
      history.replace({...history.location, newState});
    }
    // Mirrors search.api.js's own hasBrowseFilter check — a landing link can
    // browse/filter with no `q` at all (category ids, a productFeatures tag,
    // brand, etc; see e.g. the /halal page's category links), so this must
    // recognise the same set of params or it silently skips the initial
    // search on mount and only recovers once something else (e.g. changing
    // branch) triggers a later search through a different path.
    if (
      this.state.params &&
      !this.state.params.q &&
      !this.state.params.first &&
      !this.state.params.listId &&
      !this.state.params.brandOwner &&
      !this.state.params.category &&
      !this.state.params.categoryNames &&
      !this.state.params.productFeatures &&
      !this.state.params.brand &&
      !this.state.params.sizeOrCut &&
      !this.state.params.origin &&
      !this.state.params.isNew
    ) {
      return;
    }
    const ownBrandTitle = this.state.params.brand || this.state.params.adTitle;
    const isPrerender = navigator.userAgent.indexOf('Prerender') > -1;
    if (ownBrandTitle && isPrerender && !this.state.hideDes) {
      getSearchCategoryDescription({
        brand: ownBrandTitle,
      });
    }
    if (searchCategoryDescription) {
      setCmsHeadTags({metaDescription: searchCategoryDescription});
    }

    // should stop trigger search again while nav back from product screen
    if (prevRoute === ROUTES.PRODUCT && !isNewSearch) {
      return;
    }
    const fulfillmentDetailsObj =
      fulfillmentDetails || this.fulfillmentDetailsFromLocal;
    const params = Object.assign({}, this.state.params, {page: 0});
    const isInitialLoad = true;
    this.updateSearchUrl(history, params, isInitialLoad);
    if (authToken) {
      const token = queryString.parse(authToken);
      if (token) {
        search(params, token.access_token || authToken, fulfillmentDetailsObj);
      }
    } else {
      search(params, null, fulfillmentDetailsObj);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location,
      auth,
      search,
      branch,
      history,
      aggression,
      prevRoute,
      loading,
      searchCategoryDescription,
    } = this.props;
    const {params, hideDes} = this.state;
    // Read-and-clear so a pandg pill click that ends up not tripping the
    // block below (e.g. re-clicking the already-active pill) can't leave
    // this set and silently swallow a later, unrelated scroll-to-top.
    const skipScrollToTop = this._skipNextScrollToTop;
    this._skipNextScrollToTop = false;
    if (branch && params && (!params.b || params.b !== branch)) {
      const newParams = {...params, ...{b: branch}};
      history.replace({
        pathname: '/search',
        search: queryString.stringify(newParams),
      });
    }
    if (prevProps.location.search !== location.search) {
      this.setState({searchTitle: null});
    }
    if (
      !prevProps.auth &&
      prevProps.auth !== auth &&
      auth.enhanced &&
      prevRoute !== ROUTES.PRODUCT
    ) {
      search(this.state.params, null, this.fulfillmentDetailsFromLocal);
    }
    if (location.search !== prevProps.location.search) {
      const params = queryString.parse(location.search);
      const prevParams = queryString.parse(prevProps.location.search);
      if (
        params.b !== prevParams.b ||
        params.q !== prevParams.q ||
        params.listId !== prevParams.listId ||
        params.brandOwner !== prevParams.brandOwner ||
        params.first !== prevParams.first ||
        params.isNew !== prevParams.isNew ||
        params.deliveryDate !== prevParams.deliveryDate
      ) {
        search(params, null, this.fulfillmentDetailsFromLocal);
        if (!skipScrollToTop) {
          this.scrollToTop();
        }
      }
    }
    if (prevProps.aggression !== aggression) {
      const title = getDisplayName(params, aggression, false);
      setPageHeadTags(loadSearchResultsData(title));
      let totalCategoryListCount = 0;
      aggression.forEach(filter => {
        if (filter.name === FILTERS_NAME.categoryList && filter.data) {
          totalCategoryListCount = getTotalCount(filter.data);
        }
      });
      if (!!totalCategoryListCount) {
        this.setState({totalCategoryListCount});
      }
    }
    if (
      prevProps.loading &&
      prevProps.loading.searchResults &&
      loading &&
      !loading.searchResults
    ) {
      this.firstSearch = false;
    }
  }

  scrollToTop = () => window.scrollTo(0, 300);

  updateSearchUrl = (history, params, isInitialLoad) => {
    const searchParams = {
      pathname: '/search',
      search: queryString.stringify(params),
    };
    if (isInitialLoad) {
      history.replace(searchParams);
    } else {
      history.push(searchParams);
    }
  };

  updateSearchParams = (updatedParams, resetPageNumber) => {
    const {
      history,
      search,
      location,
      setCurrentRoute,
      searchResultsData,
    } = this.props;
    const urlParams = queryString.parse(location.search);
    let params = Object.assign({}, urlParams, updatedParams);
    if (resetPageNumber) {
      params = Object.assign({}, params, {page: 0});
    }
    if (params.category) {
      delete params.categoryNames;
    }
    this.updateSearchUrl(history, params);
    this.setState({params});
    setCurrentRoute(ROUTES.SEARCH);

    search(params, null, this.fulfillmentDetailsFromLocal);
  };

  // Switching P&G sub-range via the pandg pill strip is a fresh category
  // jump, not a filter tweak — clear the other filter/browse params rather
  // than merging onto them, same as clearFilters does.
  handlePandgCategoryClick = (category, event) => {
    // Blur immediately — on mobile, tapping a button inside the horizontally
    // scrollable pill strip otherwise leaves it focused, and the browser's
    // scroll-focused-element-into-view behaviour can yank the page around
    // once the results re-render below it.
    if (event && event.currentTarget) {
      event.currentTarget.blur();
    }
    // Belt-and-braces: whatever ends up moving the page (focus handling,
    // reflow from the new results, mobile browser quirks) tends to settle a
    // frame or two after this click handler returns, so re-assert the
    // pre-click scroll position after the browser's own adjustments land
    // rather than trying to out-guess every possible cause.
    const scrollYBeforeClick = window.scrollY;
    const restoreScrollPosition = () => {
      if (window.scrollY !== scrollYBeforeClick) {
        window.scrollTo(0, scrollYBeforeClick);
      }
    };
    requestAnimationFrame(() => requestAnimationFrame(restoreScrollPosition));
    const {b, size} = this.state.params || {};
    // Switching pandg pills re-runs the search like any other category jump,
    // which would otherwise trigger the componentDidUpdate scroll-to-300
    // used for real search-bar submissions — skip it just this once so
    // picking a pill doesn't yank the page away from where it was clicked.
    this._skipNextScrollToTop = true;
    this.updateSearchParams(
      {
        q: category.query,
        adTitle: category.adTitle,
        b,
        size,
        pandg: 'true',
        category: undefined,
        categoryNames: undefined,
        brand: undefined,
        sizeOrCut: undefined,
        origin: undefined,
        productFeatures: undefined,
        listId: undefined,
        brandOwner: undefined,
        advanced: undefined,
        isNew: undefined,
        first: undefined,
      },
      true
    );
  };

  // Halal category pills store a full pre-built search URL (see
  // HALAL_CATEGORIES/HALAL_ALL_CATEGORY) rather than PandG's simple
  // {query, adTitle} shape, since the halal links vary — most filter on
  // `category`, one on `q`, and only some set `sortType`. Parsing the
  // target URL's own query string at click/active-check time means each
  // pill just works, whichever shape its particular category happens to use.
  parseHalalCategoryParams = category =>
    queryString.parse(category.url.split('?')[1]);

  isHalalCategoryActive = (params, category) => {
    const categoryParams = this.parseHalalCategoryParams(category);
    return categoryParams.category
      ? params.category === categoryParams.category
      : params.q === categoryParams.q;
  };

  handleHalalCategoryClick = (category, event) => {
    if (event && event.currentTarget) {
      event.currentTarget.blur();
    }
    const scrollYBeforeClick = window.scrollY;
    const restoreScrollPosition = () => {
      if (window.scrollY !== scrollYBeforeClick) {
        window.scrollTo(0, scrollYBeforeClick);
      }
    };
    requestAnimationFrame(() => requestAnimationFrame(restoreScrollPosition));
    const {b, size} = this.state.params || {};
    this._skipNextScrollToTop = true;
    this.updateSearchParams(
      {
        q: undefined,
        category: undefined,
        sortType: undefined,
        productFeatures: undefined,
        adTitle: undefined,
        advanced: undefined,
        categoryNames: undefined,
        brand: undefined,
        sizeOrCut: undefined,
        origin: undefined,
        listId: undefined,
        brandOwner: undefined,
        isNew: undefined,
        first: undefined,
        ...this.parseHalalCategoryParams(category),
        b,
        size,
        halal: 'true',
      },
      true
    );
  };

  clearFilters = () => {
    const {
      q,
      b,
      size,
      advanced,
      category,
      adTitle,
      listId,
      brandOwner,
      first,
    } = this.state.params;
    let params;

    if (listId) {
      // Clearing filters on a curated list returns to the whole list, not to
      // a keyword search.
      params = {b, size, listId, brandOwner, adTitle};
    } else if (!q && first) {
      // A campaign link with no `q` is defined by its pinned items, so dropping
      // `first` here would leave the page with nothing to search on at all.
      params = {b, size, first, adTitle};
    } else if (
      q &&
      (q === MATCH_ALL_QUERY || q.indexOf(QUERY_PROMO_TAG_ID) > -1) &&
      advanced === 'true'
    ) {
      params = {q, b, advanced, category, adTitle};
    } else {
      params = {q, b, size};
    }
    // The link chose to hide the related strip; clearing filters is still that link's search.
    if (isRelatedProductsOff(this.state.params)) {
      params[SEARCH_RELATED_PARAM] = SEARCH_RELATED_OFF;
    }

    const {history, search} = this.props;
    this.updateSearchUrl(history, params);
    search(params);
    this.scrollToTop();
  };

  toggleGridView = () => this.setState({gridView: !this.state.gridView});

  // A click-through from the related strip: recorded, then the ordinary product navigation. The
  // product page keeps the strip's searchId and analyticsParams for any add made there.
  onRelatedProductClick = (itemId, context) => {
    const {
      relatedProductsData,
      relatedProductClicked,
      onProductClick,
    } = this.props;
    relatedProductClicked({
      searchId: relatedProductsData && relatedProductsData.searchId,
      parentSearchId: relatedProductsData && relatedProductsData.parentSearchId,
      strategy: relatedProductsData && relatedProductsData.strategy,
      itemId,
      searchPosition: context && context.searchPosition,
    });
    if (onProductClick) {
      onProductClick(itemId, context);
    }
  };

  // "Search instead for mklk": the same search, with the customer's own words and no correction.
  // The flag goes in the URL so infinite scroll and filter changes keep honouring it.
  searchInstead = () => {
    const {searchMeta, searchInsteadClicked} = this.props;
    const {params} = this.state;
    searchInsteadClicked({
      searchId: searchMeta && searchMeta.searchId,
      query: (searchMeta && searchMeta.query) || (params && params.q),
      correctedQuery: searchMeta && searchMeta.correctedQuery,
    });
    this.updateSearchParams({[SEARCH_CORRECT_PARAM]: SEARCH_CORRECT_OFF}, true);
  };

  loadMore = () => {
    const {moreSearch, location, page, fulfillmentDetails} = this.props;
    const urlParams = queryString.parse(location.search);
    const params = Object.assign({}, urlParams, {
      page: page.number + 1,
    });
    this.props.history.push({
      pathname: '/search',
      search: `?${queryString.stringify(params)}`,
    });
    moreSearch(params, null, fulfillmentDetails);
  };

  applyFilters = () => {
    this.closeFilterInMobile();
  };

  toggleFilterInMobile = () =>
    this.setState(
      prev => ({showFilterInMobile: !prev.showFilterInMobile}),
      () => {
        if (this.state.showFilterInMobile) {
          this.lockBodyScroll();
          if (this.filtersScrollRef.current) {
            this.filtersScrollRef.current.scrollTop = 0;
          }
        } else {
          this.unlockBodyScroll();
        }
      }
    );

  closeFilterInMobile = () => {
    this.unlockBodyScroll();
    this.setState({showFilterInMobile: false});
  };

  render() {
    const {
      searchResultsData,
      page,
      branch,
      loading,
      aggression,
      updateBasket,
      updateItem,
      removeItem,
      basketHashMap,
      basket,
      onProductClick,
      deviceInfo,
      keywordSearch,
      searchCategoryDescription,
      featuredResultsData,
      searchMeta,
      relatedProductsData,
    } = this.props;
    const searchResults = syncBasketQuantityWithProducts(
      basketHashMap,
      searchResultsData
    );
    // Featured cards go through the same basket sync as ordinary results, or their Add button
    // never flips to a quantity stepper once the item is in the basket.
    const featuredProducts = syncBasketQuantityWithProducts(
      basketHashMap,
      (featuredResultsData || []).map(entry => entry.product)
    );
    const featuredEntries = (featuredResultsData || []).map((entry, index) => ({
      ...entry,
      product: featuredProducts[index],
    }));
    const displayItems = spliceFeaturedIntoResults(
      searchResults,
      featuredEntries
    );
    const {
      params,
      gridView,
      showFilterInMobile,
      showSortDropdown,
      searchTitle,
      isCurrentSearch,
      hideDes,
      totalCategoryListCount,
    } = this.state;
    // The first search re-runs over the server-rendered results and leaves them on screen; any later
    // one swaps them for a spinner. The correction describes the results, so it shows exactly when
    // they do - never over a spinner for a search it doesn't belong to.
    const resultsOnScreen =
      !(loading && loading.searchResults) || this.firstSearch;
    const correctedQuery =
      (resultsOnScreen && searchMeta && searchMeta.correctedQuery) || null;
    const typedQuery = (searchMeta && searchMeta.query) || params.q;
    // A corrected search's results are for the corrected words, so the title and breadcrumb say
    // "milk", not the "mlk" that was typed; the banner keeps the typed words for "Search instead".
    const titleParams = correctedQuery
      ? {...params, q: correctedQuery}
      : params;
    const isPandg = params.pandg === 'true';
    const isHalal = params.halal === 'true';
    let isSearchAll;
    try {
      isSearchAll = decodeURIComponent(params.q) === '*';
    } catch (e) {
      isSearchAll = false;
    }
    const isSearchAllAdvanced = isSearchAll && params.advanced === 'true';
    const isCategorySearch = isSearchAllAdvanced && params.isNew !== 'true';
    // A typed keyword is a search; a category or other listing is browsing.
    const listingSource =
      params.q && !isSearchAll
        ? ANALYTICS_SOURCES.SEARCH
        : ANALYTICS_SOURCES.BROWSE;
    const isNewSearch = isSearchAllAdvanced && params.isNew === 'true';
    const displayName = searchTitle
      ? searchTitle
      : getDisplayName(titleParams, aggression, isSearchAllAdvanced);
    const appliedFilters = {
      sizeOrCut: !!params.sizeOrCut,
      origin: !!params.origin,
      brand: !!params.brand,
      productFeatures: !!params.productFeatures,
      categoryList: !!params.category,
    };
    const renderSearchResultItems =
      displayItems.length > 0 &&
      displayItems.map((item, index) => {
        const key = `${item.isFeatured ? 'featured' : 'result'}-${
          item.product.itemId
        }-${index}`;
        const card = (
          <Product
            product={item.product}
            branch={branch}
            key={key}
            isListView={!gridView}
            onProductClick={onProductClick}
            loading={loading}
            basketHashMap={basketHashMap}
            updateBasket={updateBasket}
            updateItem={updateItem}
            removeItem={removeItem}
            fulfillmentType={basket && basket.fulfillmentType}
            deviceInfo={deviceInfo}
            source={
              item.isFeatured
                ? ANALYTICS_SOURCES.FEATURED_SEARCH
                : listingSource
            }
            campaignId={item.isFeatured ? item.campaignId : undefined}
            searchId={item.product._searchId}
            searchPosition={item.searchPosition}
            keywordSearch={keywordSearch}
          />
        );
        // The trial card is an ordinary product card in trial chrome: FeaturedProduct wraps it,
        // rather than Product taking an isFeatured prop, so nothing shared has to be unpicked when
        // the trial ends.
        return item.isFeatured ? (
          <FeaturedProduct
            key={key}
            reason={item.reason}
            title={item.title}
            intro={item.intro}
          >
            {card}
          </FeaturedProduct>
        ) : (
          card
        );
      });
    const renderCorrectionBanner = correctedQuery && (
      <CorrectionBanner>
        {`${SEARCH_CORRECTED_PREFIX} `}
        <CorrectedQuery>{correctedQuery}</CorrectedQuery>
        {`. ${SEARCH_INSTEAD_PREFIX} `}
        <SearchInsteadButton type="button" onClick={this.searchInstead}>
          {typedQuery}
        </SearchInsteadButton>
      </CorrectionBanner>
    );
    // A slow related response can land after the next search has started, so it is shown only
    // when it belongs to the search on screen - and, as searchMeta outlives a search in flight,
    // only while that search's results are actually showing.
    const relatedForThisSearch =
      resultsOnScreen &&
      relatedProductsData &&
      relatedProductsData.parentSearchId &&
      searchMeta &&
      relatedProductsData.parentSearchId === searchMeta.searchId &&
      relatedProductsData.results.length > 0
        ? relatedProductsData
        : null;
    const relatedProducts = relatedForThisSearch
      ? syncBasketQuantityWithProducts(
          basketHashMap,
          relatedForThisSearch.results
        )
      : [];
    const relatedHeading = getRelatedHeading(relatedForThisSearch);
    // A search that found nothing gets one heading, the strip's: the breadcrumb and the "couldn't find
    // any products matching ..." sentence already name what was searched for, and a second large
    // title above them reads as clutter (design: "No results search experience").
    const hideResultsTitle =
      !!relatedForThisSearch &&
      !!page &&
      page.totalElements === 0 &&
      !!relatedHeading;
    // On every add/remove/click from the strip, so GA4 can split them by rule without joining to
    // the impression log.
    const relatedAnalyticsParams = relatedForThisSearch && {
      relatedStrategy: relatedForThisSearch.strategy,
      parentSearchId: relatedForThisSearch.parentSearchId,
    };
    // "Similar to ..." always carries a product name, so it is a plain subheading aligned with the
    // cards (design board 3), whether or not the search found anything. The short fallback
    // headings after a search that found nothing (Buy Again, New Products, Results for "wings")
    // take the page-title treatment (design: "No results search experience").
    const isSubheading =
      !!relatedForThisSearch &&
      relatedForThisSearch.strategy === RELATED_STRATEGY.SIMILAR;
    const renderRelatedProducts = relatedForThisSearch && (
      <RelatedSection>
        {relatedHeading && !isSubheading && (
          <RelatedHeadingRow>
            <LeftLine />
            <RelatedHeading>{relatedHeading}</RelatedHeading>
            <RightLine />
          </RelatedHeadingRow>
        )}
        <RelatedGrid>
          {relatedHeading && isSubheading && (
            <RelatedSubheading>{relatedHeading}</RelatedSubheading>
          )}
          {relatedProducts.map((product, index) => (
            <Product
              product={product}
              branch={branch}
              key={`related-${product.itemId}-${index}`}
              isListView={!gridView}
              onProductClick={this.onRelatedProductClick}
              loading={loading}
              basketHashMap={basketHashMap}
              updateBasket={updateBasket}
              updateItem={updateItem}
              removeItem={removeItem}
              fulfillmentType={basket && basket.fulfillmentType}
              deviceInfo={deviceInfo}
              source={ANALYTICS_SOURCES.RELATED_SEARCH}
              searchId={relatedForThisSearch.searchId}
              searchPosition={index}
              analyticsParams={relatedAnalyticsParams}
              keywordSearch={keywordSearch}
            />
          ))}
        </RelatedGrid>
      </RelatedSection>
    );
    const renderEmptyResults = loading &&
      !loading.searchResults &&
      loading.searchResults !== null &&
      searchResults &&
      searchResults.length === 0 && (
        <NoResult>
          {typedQuery && isTypedSearch(params) ? (
            <Fragment>
              {`${NO_RESULTS_FOR_QUERY_PREFIX} \u201c`}
              <NoResultQuery>{typedQuery}</NoResultQuery>
              {'\u201d.'}
            </Fragment>
          ) : (
            NO_RESULTS_MESSAGE
          )}
        </NoResult>
      );
    const renderFilterTitle = page && !!page.totalElements && (
      <FilterInfo>
        <Title>{`Filter ${page.totalElements} products by:`}</Title>
        <ClearFilter onClick={this.clearFilters}>clear filters</ClearFilter>
      </FilterInfo>
    );
    const selectedFilterItems = [];
    if (aggression) {
      const traverse = items => {
        items.forEach(item => {
          if (item.selected) selectedFilterItems.push(item);
          if (item.counts && item.counts.length > 0) traverse(item.counts);
        });
      };
      aggression.forEach(filter =>
        traverse(filter.data || filter.counts || [])
      );
    }
    const renderFilterPills = selectedFilterItems.length > 0 && (
      <FilterPillsWrapper>
        <div>
          {selectedFilterItems.map(item => (
            <FilterPill
              key={item.id}
              onClick={() => {
                const unqueryParams = queryString.parse(item.unquery);
                const {q, category: currentCategory} = this.state.params || {};
                if (q === '*' && unqueryParams.category === '') {
                  const queryParams = queryString.parse(item.query);
                  const topCategory =
                    queryParams.category && queryParams.category.split(',')[0];
                  // If topCategory equals currentCategory this is already the
                  // top-level item — clear the filter entirely rather than
                  // re-setting the same value.
                  this.updateSearchParams({
                    ...unqueryParams,
                    category:
                      topCategory !== currentCategory ? topCategory : undefined,
                  });
                } else {
                  this.updateSearchParams(unqueryParams);
                }
              }}
            >
              {item.name}
            </FilterPill>
          ))}
        </div>
      </FilterPillsWrapper>
    );
    const breadCrumbLinks = getBreadCrumbLinks(isSearchAll, aggression);
    const renderBreadCrumbLinks =
      breadCrumbLinks &&
      Array.isArray(breadCrumbLinks) &&
      breadCrumbLinks.map((link, i) => (
        <BreadCrumbLink
          link={link}
          key={link.id}
          length={breadCrumbLinks.length}
          index={i}
          callback={this.updateSearchParams}
        />
      ));
    const renderFilterButton = searchResults && searchResults.length > 0 && (
      <FilterButtonWrapper>
        <FilterButton onClick={this.toggleFilterInMobile}>
          <span>{showFilterInMobile ? 'Hide Filters' : 'Show Filters'}</span>
        </FilterButton>
      </FilterButtonWrapper>
    );
    const renderFilters = aggression && totalCategoryListCount !== 0 && (
      <Filters
        params={params}
        updateSearchParams={this.updateSearchParams}
        filters={aggression}
        filtersCount={aggression.data || aggression.counts}
        appliedFilters={appliedFilters}
        showInMobile={showFilterInMobile}
        isCategorySearch={isCategorySearch}
        isCurrentSearch={isCurrentSearch}
        closedByDefault={deviceInfo && deviceInfo.isPhone}
        totalCategoryListCount={totalCategoryListCount}
      />
    );
    const searchResultTitle = titleParams.adTitle
      ? titleParams.adTitle
      : titleParams.q
      ? titleParams.q
      : displayName;
    const renderCurrentSearchTextContent =
      searchTitle ||
      getSearchHeading(searchResultTitle, {
        isNewSearch,
        isCuratedList: !!params.listId,
      });
    const renderCurrentSearchTextField = isCategorySearch ? (
      renderBreadCrumbLinks
    ) : (
      <CurrentPage>
        <Separator>&gt;</Separator>
        <BreadCrumbResult>{renderCurrentSearchTextContent}</BreadCrumbResult>
      </CurrentPage>
    );
    const hasMore = page && page.number < page.totalPages - 1;
    const renderSearchResultsLoading = !this.firstSearch &&
      loading &&
      loading.searchResults && <Loading />;
    const renderLoadMore = hasMore &&
      totalCategoryListCount > LONG_CATEGORY_LIST_FILTER_LENGTH && (
        <LoadMoreButton onClick={this.loadMore}>Load more</LoadMoreButton>
      );
    const renderSearchResults = resultsOnScreen && (
      <InfiniteScroll
        hasMore={hasMore}
        next={this.loadMore}
        dataLength={searchResults.length}
        scrollThreshold={SCROLL_THRESHOLD}
        loader={
          <LoadMore>
            <Loading />
          </LoadMore>
        }
      >
        {renderSearchResultItems}
        {renderLoadMore}
      </InfiniteScroll>
    );
    const renderGoTop = page && page.number > 0 && <ToTheTop />;
    const renderResultsTitle = displayName && (
      <Fragment>
        <LeftLine />
        <NameWrapper>{displayName}</NameWrapper>
        <RightLine />
      </Fragment>
    );
    const renderCategoryDescription = searchCategoryDescription && !hideDes && (
      <CategoryDescription>{searchCategoryDescription}</CategoryDescription>
    );
    const renderAdTitleDescription = this.adTitleDescription && !hideDes && (
      <CategoryDescription>{this.adTitleDescription}</CategoryDescription>
    );
    const sortOptions = params.listId
      ? [CURATED_LIST_SORT_OPTION, ...SEARCH_SORT_OPTIONS]
      : SEARCH_SORT_OPTIONS;
    // Mirrors the service default: a listId browse with no explicit sortType
    // comes back in curated order.
    const currentSortType =
      params.sortType ||
      (params.listId ? SEARCH_SORT_TYPE.LIST : SEARCH_SORT_TYPE.RELEVANCE);
    const renderPandgBanner = isPandg && (
      <PandgBannerSection>
        <PandgBanner>
          <PandgBannerImg
            src={PANDG_BANNER_IMAGE_URL}
            alt="P&G PRO cleaning products being delivered to a commercial kitchen"
          />
          <PandgBannerOverlay />
          <PandgBannerContent>
            <PandgLogoBadge>
              <PandgLogo
                src={pandgLogo}
                alt="JJ Foodservice in partnership with P&G PRO"
              />
            </PandgLogoBadge>
            {/* <PandgEyebrow>
              OFFICIAL UK DISTRIBUTOR &mdash; P&amp;G PRO
            </PandgEyebrow> */}
            <PandgHeading>Trusted P&G PRO Cleaning Solutions</PandgHeading>
            <PandgSub>Now available through JJ Foodservice</PandgSub>
          </PandgBannerContent>
        </PandgBanner>
      </PandgBannerSection>
    );
    const renderPandgPillStrip = isPandg && (
      <PandgPillSection>
        <PandgPillStrip>
          <PandgChip
            $active={params.q === PANDG_ALL_CATEGORY.query}
            onClick={e => this.handlePandgCategoryClick(PANDG_ALL_CATEGORY, e)}
          >
            <PandgChipDot $active={params.q === PANDG_ALL_CATEGORY.query} />
            {PANDG_ALL_CATEGORY.label}
          </PandgChip>
          {PANDG_CATEGORIES.map(category => (
            <PandgChip
              key={category.key}
              $active={params.q === category.query}
              onClick={e => this.handlePandgCategoryClick(category, e)}
            >
              <PandgChipDot $active={params.q === category.query} />
              {category.label}
            </PandgChip>
          ))}
        </PandgPillStrip>
      </PandgPillSection>
    );
    const renderHalalBanner = isHalal && (
      <HalalBannerSection>
        <HalalBanner>
          <HalalBannerImg
            src={HALAL_BANNER_IMAGE_URL}
            alt="Halal wholesale range"
          />
          <HalalBannerOverlay />
          <HalalBannerContent>
            <HalalCertBadge>
              <span>حلال</span>
              <span>HALAL</span>
            </HalalCertBadge>
            <HalalHeading>
              Halal Wholesale — Chicken, Meat &amp; Doner
            </HalalHeading>
            <HalalSub>
              Explore our halal range — delivered next day* or collect in
              branch.
            </HalalSub>
          </HalalBannerContent>
        </HalalBanner>
      </HalalBannerSection>
    );
    const renderHalalPillStrip = isHalal && (
      <HalalPillSection>
        <HalalPillStrip>
          <HalalChip
            $active={this.isHalalCategoryActive(params, HALAL_ALL_CATEGORY)}
            onClick={e => this.handleHalalCategoryClick(HALAL_ALL_CATEGORY, e)}
          >
            <HalalChipDot
              $active={this.isHalalCategoryActive(params, HALAL_ALL_CATEGORY)}
            />
            {HALAL_ALL_CATEGORY.label}
          </HalalChip>
          {HALAL_CATEGORIES.map(category => (
            <HalalChip
              key={category.key}
              $active={this.isHalalCategoryActive(params, category)}
              onClick={e => this.handleHalalCategoryClick(category, e)}
            >
              <HalalChipDot
                $active={this.isHalalCategoryActive(params, category)}
              />
              {category.label}
            </HalalChip>
          ))}
        </HalalPillStrip>
      </HalalPillSection>
    );
    return (
      <Fragment>
        <BreadCrumb>
          {!isPandg && !isHalal && (
            <span>
              <BreadCrumbLinks to="/">Home</BreadCrumbLinks>
              {renderCurrentSearchTextField}
            </span>
          )}
          {page && page.totalElements > 0 && (
            <ProductCount>{page.totalElements} Products found</ProductCount>
          )}
        </BreadCrumb>
        {renderPandgBanner}
        {renderPandgPillStrip}
        {renderHalalBanner}
        {renderHalalPillStrip}
        <ToolBar>
          <SortWrapper ref={this.sortWrapperRef}>
            <SortButton onClick={this.toggleSortDropdown}>
              {`Sort: ${
                (
                  sortOptions.find(o => o.value === currentSortType) ||
                  sortOptions[0]
                ).label
              }`}
            </SortButton>
            {showSortDropdown && (
              <SortDropdownPanel>
                {sortOptions.map(opt => (
                  <SortDropdownItem
                    key={opt.value}
                    $active={currentSortType === opt.value}
                    onClick={() => this.selectSort(opt.value)}
                  >
                    {opt.label}
                  </SortDropdownItem>
                ))}
              </SortDropdownPanel>
            )}
          </SortWrapper>
          {renderFilterButton}
        </ToolBar>
        {!hideResultsTitle && <ResultsTitle>{renderResultsTitle}</ResultsTitle>}
        <Container>
          <FilterOverlayBackdrop
            $show={showFilterInMobile}
            onClick={this.closeFilterInMobile}
          />
          <FiltersWrapper $showInMobile={showFilterInMobile}>
            <FiltersScrollArea ref={this.filtersScrollRef}>
              {renderFilterTitle}
              {renderFilters}
            </FiltersScrollArea>
            <FiltersButtons>
              <DoneButton onClick={this.applyFilters}>Apply Filters</DoneButton>
            </FiltersButtons>
          </FiltersWrapper>
          <ResultsPanel>
            {renderFilterPills}
            {renderCategoryDescription}
            {renderAdTitleDescription}
            {renderCorrectionBanner}
            <ResultsWrapper $gridView={gridView}>
              {renderSearchResultsLoading}
              {renderSearchResults}
              {renderEmptyResults}
              {renderGoTop}
            </ResultsWrapper>
            {renderRelatedProducts}
          </ResultsPanel>
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  searchResultsData: state.searchResults,
  featuredResultsData: state.featuredResults,
  searchMeta: state.searchMeta,
  relatedProductsData: state.relatedProducts,
  loading: state.loading,
  aggression: state.aggression,
  page: state.page,
  route: state.route,
  branch: state.branch,
  auth: state.auth,
  basketHashMap: state.basketHashMap,
  basket: state.basket,
  fulfillmentDetails: state.fulfillmentDetails,
  prevRoute: state.prevRoute,
  searchCategoryDescription: state.searchCategoryDescription,
});

const mapDispatchToProps = dispatch => ({
  search: bindActionCreators(search, dispatch),
  moreSearch: bindActionCreators(moreSearch, dispatch),
  setCurrentRoute: bindActionCreators(setCurrentRoute, dispatch),
  getSearchCategoryDescription: bindActionCreators(
    getSearchCategoryDescription,
    dispatch
  ),
  setPrevRoute: bindActionCreators(setPrevRoute, dispatch),
  searchInsteadClicked: bindActionCreators(searchInsteadClicked, dispatch),
  relatedProductClicked: bindActionCreators(relatedProductClicked, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);
